module.exports = __webpack_public_path__ + "static/placeholder-2f121984226a551a1b90fd8cfea5d71f.jpg";